import React from "react";
// The defaultSettings is only used when a component does not have a matching Provider above it in the tree
const defaultSettings = {
    alwaysApplyCardMargins: false,
};
export const SettingsContext = React.createContext(defaultSettings);
export const SettingsProvider = ({ children, settings = defaultSettings }) => {
    return React.createElement(SettingsContext.Provider, { value: settings }, children);
};
export default SettingsProvider;
//# sourceMappingURL=index.js.map